"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MonitorPriceList = MonitorPriceList;
exports.adjustPriceApprove = adjustPriceApprove;
exports.adjustPriceDetail = adjustPriceDetail;
exports.adjustPriceList = adjustPriceList;
exports.adjustPriceRecord = adjustPriceRecord;
exports.dashboardStatistics = dashboardStatistics;
exports.getCalculatePriceList = getCalculatePriceList;
exports.getMonitorRecordDetailApi = getMonitorRecordDetailApi;
exports.getMonitorRecordListApi = getMonitorRecordListApi;
exports.getMonitorRuleDetailByProductSku = getMonitorRuleDetailByProductSku;
exports.getPriceList = getPriceList;
exports.getPriceTrendApi = getPriceTrendApi;
exports.priceTrend = priceTrend;
exports.saveCalculatePriceList = saveCalculatePriceList;
exports.submitMonitorPriceAdjust = submitMonitorPriceAdjust;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 调价商品分页列表
 * @param pram
 */
function getPriceList(data) {
  return (0, _request.default)({
    url: '/admin/platform/price/list',
    method: 'post',
    data: data
  });
}
/**
 * 调价商品分页列表
 * @param pram
 */
function getCalculatePriceList(data) {
  return (0, _request.default)({
    url: '/admin/platform/price/getCalculatePriceList',
    method: 'post',
    data: data
  });
}
/**
 * 保存调价商品
 * @param pram
 */
function saveCalculatePriceList(data) {
  return (0, _request.default)({
    url: '/admin/platform/price/save',
    method: 'post',
    data: data
  });
}
/**
 * 调价申请分页列表
 * @param pram
 */
function adjustPriceList(data) {
  return (0, _request.default)({
    url: '/admin/platform/price/adjustment/list',
    method: 'post',
    data: data
  });
}
/**
 * 调价申请详情
 * @param pram
 */
function adjustPriceDetail(data) {
  return (0, _request.default)({
    url: '/admin/platform/price/adjustment/detail',
    method: 'post',
    data: data
  });
}
/**
 * 调价记录分页列表
 * @param pram
 */
function adjustPriceRecord(specId) {
  return (0, _request.default)({
    url: '/admin/platform/price/record/list',
    method: 'get',
    params: {
      specId: specId
    }
  });
}
/**
 * 调价申请审批
 * @param pram
 */
function adjustPriceApprove(data) {
  return (0, _request.default)({
    url: 'admin/platform/price/batch/approve',
    method: 'post',
    data: data
  });
}
/**
 * 调价申请审批
 * @param pram
 */
function dashboardStatistics() {
  return (0, _request.default)({
    url: 'admin/platform/price/monitor/dashboard/statistics',
    method: 'get'
  });
}
/**
 * 调价商品趋势
 * @param pram
 */
function priceTrend(data) {
  return (0, _request.default)({
    url: 'admin/platform/price/monitor/dashboard/trend',
    method: 'GET',
    params: data
  });
}
// ========== 监控记录详情 模块 ==========

/**
 * 获取监控记录详情
 * @param id 监控记录ID
 */
function getMonitorRecordDetailApi(productId, skuId) {
  return (0, _request.default)({
    url: "admin/platform/price/monitor/product/info/".concat(productId),
    method: 'get',
    params: {
      skuId: skuId
    }
  });
}

/**
 * 获取监控记录列表
 * @param id 商品/规则ID
 * @param params 分页参数 { page, limit }
 */
function getMonitorRecordListApi(params) {
  return (0, _request.default)({
    url: "admin/platform/price/monitor/record/list",
    method: 'get',
    params: params
  });
}
/**
 * 获取商品监控规则列表 
 * @param params 筛选参数
 * { page, limit, productId, skuId }
 */

function getPriceTrendApi(params) {
  return (0, _request.default)({
    url: "admin/platform/price/monitor/product/".concat(params.productId, "/trend"),
    method: 'get',
    params: params
  });
}
/**
 * 监控调价提交
 * @param data { adjustReason, priceSource, remark, specIds }
 */
function submitMonitorPriceAdjust(data) {
  return (0, _request.default)({
    url: '/admin/platform/price/monitor/submit',
    method: 'post',
    data: data
  });
}
/**
* 监控调价提交
* @param data { adjustReason, priceSource, remark, specIds }
*/
function MonitorPriceList(data) {
  return (0, _request.default)({
    url: 'admin/platform/price/monitor/product/list',
    method: 'get',
    params: data
  });
}
/**
 * 获取商品监控规则详情
 * @param productId 商品ID
 * @param skuId 商品skuID
 */
function getMonitorRuleDetailByProductSku(productId, skuId) {
  return (0, _request.default)({
    url: "/admin/platform/price/monitor/rule/product/".concat(productId),
    method: 'get',
    params: {
      skuId: skuId
    }
  });
}